import { erpAxios } from '..';

const addProcjenaRizika = async (data) => {
  const res = await erpAxios.post(`/procjenaRizika/add`, data);
  return res;
};

export default addProcjenaRizika;
